import gql from 'graphql-tag';

export const GOOGLE_ONE_TAP_SIGN_IN_MUTATION = gql`
    mutation socialSignInGoogleOneTap($accessToken: String!) {
        socialSignInGoogleOneTap(accessToken: $accessToken) {
            success
        }
    }
`;
